import React from 'react';
import * as cardHelper from '../../../app/Helper/CardHelper';

/**
 * 카드 할부 컴포넌트
 */
function CardMonthlyFree({ cardMonthlyFree }) {
  const { month, free } = cardHelper.getMaxMonth(cardMonthlyFree.data);
  return (
    <p>
      신용카드 최대 <span className="text_color2">{month}개월</span> {free}
    </p>
  );
}

export default CardMonthlyFree;
